<template>
	<v-app>
		<v-main>
			<FullContainer />
			<Modals />
		</v-main>
	</v-app>
</template>

<script>
	import { mapGetters } from "vuex"
	import * as firebase from 'firebase/app'
	import 'firebase/auth'
	import FullContainer from './components/Layout/FullContainer'
	import {getFBAuthToken} from './helpers/api/user'
	import Modals from './components/Modals/Index'

	export default {
		name: 'App',
		components: {FullContainer, Modals},
		computed: {
			...mapGetters(["userData"])
		},
		watch:{
			userData: function(data){
				if(!this.$store.state.primaryDB){
					this.setFirebaseDB(data)
				}
			}
		},
		data: () => ({}),
		methods: {
			async setFirebaseDB(user){
				const firebaseConfigPrimaryDB = {
					apiKey: "AIzaSyAG7ToUumc5o0RLc_QEh2FPZLv1Iu_HpUc",
					authDomain: "sosclick-1d067.firebaseapp.com",
					databaseURL: user.info.cuadrante.primary_fdb_url,
					projectId: "sosclick-1d067",
					storageBucket: "sosclick-1d067.appspot.com",
					messagingSenderId: "614190041654",
					appId: "1:614190041654:web:472e522e02a23dc8986697"
				};
				const firebaseConfigTracking = {
					apiKey: "AIzaSyAG7ToUumc5o0RLc_QEh2FPZLv1Iu_HpUc",
					authDomain: "sosclick-1d067.firebaseapp.com",
					databaseURL: user.info.cuadrante.tracking_fdb_url,
					projectId: "sosclick-1d067",
					storageBucket: "sosclick-1d067.appspot.com",
					messagingSenderId: "614190041654",
					appId: "1:614190041654:web:472e522e02a23dc8986697"
				};
				const primaryDB = await firebase.initializeApp(firebaseConfigPrimaryDB, 'primaryDB')
				const trackingDB = await firebase.initializeApp(firebaseConfigTracking, 'trackingDB')
				this.$store.commit('setPrimaryDB', primaryDB)
				this.$store.commit('setTrackingDB', trackingDB)
				await this.loginInFB()
			},
			async loginInFB(){
				const self = this
				return new Promise((resolve) => {
					getFBAuthToken()
						.then(async function(response){
							const token = response.customToken
							if (token) {
								await self.checkLoginPrimaryDB(token)
							}
							resolve(true)
						})
						.catch(function(){
							resolve(false)
						})
				})
			},
			checkLoginPrimaryDB(token){
				return new Promise((resolve) => {
					let loggedPrimaryDB = this.$store.state.primaryDB.auth()
						.onAuthStateChanged(async (user) => {
							if(!user){
								await this.$store.state.primaryDB.auth().signInWithCustomToken(token)
							}
							loggedPrimaryDB()
							resolve(user)
						})
				})
			}
		}
	};
</script>
